<template>
  <div class="paychological-page">
     <!-- 1. Banner 区域 (深色) -->
   <section class="lib-banner">
  <div class="banner-overlay"></div>
  <div class="container">
    <div class="banner-content">
      <h1>德育评价系统</h1>
      <p class="subtitle">以数据驱动德育，用评价赋能成长</p>
      <p class="description">构建全过程、多维度、可视化的德育评价体系，帮助学校科学评价学生品德发展，助力家校共育，促进学生全面成长。</p>
      <button class="btn-primary" @click="contactUs">
        合作咨询 <span class="divider">|</span> 020-82038386
      </button>
    </div>
  </div>
</section>

<!-- 2. 过程性评价 -->
    <section class="section process-section">
      <div class="container">
        <div class="section-grid">
          <div class="section-text">
            <h2>过程性评价</h2>
            <h3>记录每一次成长</h3>
            <p class="desc">覆盖德育互动、日常行为、课堂表现、志愿服务、社会实践等场景，随时随地记录学生发展轨迹，让评价更真实、更全面。</p>
          </div>
          <div class="dashed-box image-container">
            <!-- 引入图片：过程性评价卡片区域 -->
            <img src="../assets/images/process-evaluation-cards.png" alt="过程性评价卡片" class="section-image" />
          </div>
        </div>
      </div>
    </section>

    <!-- 3. 多维数据采集与分析 -->
    <section class="section data-section">
      <div class="container">
        <div class="section-grid reverse">
          <div class="dashed-box image-container big-image">
            <!-- 引入图片：数据分析图表区域 -->
            <img src="../assets/images/data-analysis-charts.png" alt="多维数据分析图表" class="section-image" />
          </div>
          <div class="section-text">
            <h2>多维数据采集与分析</h2>
            <h3>全面洞察成长</h3>
            <p class="desc">从品德、行为、能力、习惯等多维度采集学生德育数据，智能分析学生发展状况，为班级管理于德育决策提供数据依据。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 4. 学生综合素质成长档案 -->
    <section class="section profile-section">
      <div class="container">
        <div class="section-grid">
          <div class="section-text">
            <h2>学生综合素质成长档案</h2>
            <h3>见证成长每一步</h3>
            <p class="desc">自动生成学生综合素质成长档案，记录成长轨迹与关键事件，支持档案导出与升学衔接，助力学生全面发展。</p>
          </div>
          <div class="dashed-box image-container">
            <!-- 引入图片：学生档案卡片区域 -->
            <img src="../assets/images/student-profile-card.png" alt="学生综合素质成长档案" class="section-image" />
          </div>
        </div>
      </div>
    </section>

    <!-- 5. 德育积分与勋章激励体系 -->
    <section class="section badge-section">
      <div class="container">
        <div class="section-grid">
          <div class="dashed-box image-container">
            <!-- 引入图片：勋章激励体系区域 -->
            <img src="../assets/images/badge-incentive-system.png" alt="德育积分与勋章激励体系" class="section-image" />
          </div>
          <div class="section-text">
            <h2>德育积分与勋章激励体系</h2>
            <h3>激发向上向善力量</h3>
            <p class="desc">通过积分量化学生德育表现，激发学生内在动力，让学生在荣誉激励中持续成长。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 6. 班级/年级德育量化看板 -->
    <section class="section dashboard-section">
      <div class="container">
        <div class="section-grid reverse">
          <div class="dashed-box image-container big-image">
            <!-- 引入图片：班级量化看板区域 -->
            <img src="../assets/images/class-dashboard-view.png" alt="班级/年级德育量化看板" class="section-image" />
          </div>
          <div class="section-text">
            <h2>班级/年级德育量化看板</h2>
            <h3>家校共育评价</h3>
            <p class="desc">可视化看实时展示班级/年级德育情况，支持家长参与评价，家校协同助力学生成长。</p>
          </div>
        </div>
      </div>
    </section>




    <!-- 底部 -->
    <AppFooter />

    <!-- 悬浮返回按钮 -->
    <button class="back-btn" @click="goBack">← 返回产品矩阵</button>
  </div>
</template>

<script>
// import AppHeader from './AppHeader.vue'
import AppFooter from './AppFooter.vue'

export default {
  name: 'AILipaychological',
  components: {  AppFooter },
  data() {
    return {
     
    }
  },
  methods: {
    goBack() {
      this.$emit('back')
    }
  }
}
</script>

<!-- <style scoped>
.container { 
  max-width: 1400px; 
  margin: 0 auto; 
  padding: 0 20px;
  position: relative;
  z-index: 2;
}

/* 1. Banner (深色背景图) */
.lib-banner {
  position: relative;
  /* 左侧深色背景，与图片左侧黑色融合 */
  background-color: #0a0a0a;
  background-image: url('../assets/images/MoraleducationEvaluation-bg.png');
  /* 高度填满容器，宽度自动按比例缩放 */
  background-size: auto 100%;
  /* 靠右对齐，人物和数据卡片完整显示 */
  background-position: right center;
  background-repeat: no-repeat;
  color: #fff;
  padding: 0;
  height: 580px;
  display: flex;
  align-items: center;
  overflow: hidden;
}

/* 渐变遮罩：左侧深色保护文字，右侧透明显示人物和卡片 */
.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    to right, 
    #0a0a0a 0%, 
    #0a0a0a 25%,
    rgba(10, 10, 10, 0.85) 40%,
    rgba(10, 10, 10, 0.4) 55%,
    transparent 70%
  );
  z-index: 1;
}

.lib-banner .container { 
  display: flex; 
  align-items: center; 
  justify-content: flex-start;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 5%;
  position: relative;
  z-index: 2;
}

.banner-content { 
  max-width: 550px;
}

.banner-content h1 { 
  font-size: 52px; 
  line-height: 1.2; 
  margin-bottom: 20px; 
  font-weight: bold;
  color: #fff;
}

.subtitle { 
  font-size: 22px; 
  color: rgba(255, 255, 255, 0.95); 
  margin-bottom: 20px; 
  font-weight: 500;
}

.description {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.75);
  line-height: 1.8;
  margin-bottom: 36px;
  max-width: 480px;
}

.btn-primary { 
  background: #10b1f2; 
  color: #fff; 
  border: none; 
  padding: 14px 32px;
  border-radius: 24px; 
  font-size: 16px; 
  cursor: pointer; 
  transition: all 0.3s;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
}

.btn-primary:hover { 
  background: #1557b0;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(26, 115, 232, 0.4);
}

.divider {
  opacity: 0.6;
  margin: 0 4px;
}

/* 响应式 */
@media (max-width: 1200px) {
  .lib-banner {
    height: 500px;
  }
  .banner-content h1 { font-size: 44px; }
}

@media (max-width: 992px) {
  .lib-banner {
    height: 450px;
  }
  .banner-content h1 { font-size: 36px; }
  .subtitle { font-size: 18px; }
  .description { font-size: 14px; }
  .banner-overlay {
    background: rgba(10, 10, 10, 0.9);
  }
}

@media (max-width: 768px) {
  .lib-banner {
    height: 400px;
  }
  .banner-content h1 { font-size: 28px; }
  .subtitle { font-size: 16px; }
  .description { font-size: 13px; }
}

/* 返回按钮 */
.back-btn {
  position: fixed; bottom: 30px; right: 30px;
  background: #1e293b; color: #fff; border: none;
  padding: 15px 30px; border-radius: 30px;
  cursor: pointer; box-shadow: 0 5px 20px rgba(0,0,0,0.3);
  z-index: 1000; font-size: 16px;
}
.back-btn:hover { background: #334155; }
</style> -->
<style scoped>
/* 全局容器 */
.container { 
  max-width: 1200px; 
  margin: 0 auto; 
  padding: 0 20px;
}

/* 通用Section样式 */
.section {
  padding: 80px 0;
}
.section-grid {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 60px;
}
.section-grid.reverse {
  flex-direction: row-reverse;
}

/* 文字区域样式 */
.section-text h2 {
  font-size: 32px;
  color: #2d3436;
  margin-bottom: 10px;
  font-weight: 700;
}
.section-text h3 {
  font-size: 24px;
  color: #2d3436;
  margin-bottom: 20px;
  font-weight: 500;
}
.section-text .desc {
  font-size: 14px;
  color: #636e72;
  line-height: 1.8;
  max-width: 400px;
}

/* 虚线框与图片容器样式 */
.dashed-box {
  /* border: 2px dashed #dfe6e9; */
  border-radius: 12px;
  /* padding: 20px; */
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-container {
  flex: 1;
  min-height: 300px; /* 保证图片区域有最小高度 */
}

.big-image {
  min-height: 400px;
}

.section-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 8px;
}

/* 1. Banner 样式 */
.lib-banner {
  position: relative;
  background-color: #0a0a0a;
  /* 假设背景图包含了右侧的人物和浮动卡片 */
  background-image: url('../assets/images/MoraleducationEvaluation-bg.png');
  background-size: auto 100%;
  background-position: right center;
  background-repeat: no-repeat;
  color: #fff;
  height: 750px;
  display: flex;
  align-items: center;
  overflow: hidden;
}
.banner-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: linear-gradient(to right, #0a0a0a 0%, #0a0a0a 20%, rgba(10,10,10,0.8) 40%, transparent 70%);
  z-index: 1;
}
.lib-banner .container {
  display: flex;
  align-items: center;
  justify-content: flex-start; /* 文字靠左 */
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 5%;
  position: relative;
  z-index: 2;
}
.banner-content { max-width: 550px; }
.banner-content h1 { font-size: 48px; margin-bottom: 20px; font-weight: bold; }
.subtitle { font-size: 20px; color: rgba(255,255,255,0.9); margin-bottom: 20px; }
.description { font-size: 14px; color: rgba(255,255,255,0.7); line-height: 1.8; margin-bottom: 30px; }
.btn-primary {
  background: #10b1f2; color: #fff; border: none;
  padding: 12px 28px; border-radius: 24px;
  font-size: 16px; cursor: pointer;
  display: inline-flex; align-items: center; gap: 8px;
  transition: all 0.3s;
}
.btn-primary:hover {
  background: #1557b0;
  transform: translateY(-2px);
}
.divider { opacity: 0.6; margin: 0 4px; }

/* 返回按钮 */
.back-btn {
  position: fixed; bottom: 30px; right: 30px;
  background: #2d3436; color: #fff; border: none;
  padding: 12px 24px; border-radius: 30px;
  cursor: pointer; box-shadow: 0 5px 15px rgba(0,0,0,0.2);
  z-index: 1000; font-size: 14px; transition: all 0.3s;
}
.back-btn:hover { background: #000; transform: translateY(-2px); }

/* 响应式调整 */
@media (max-width: 992px) {
  .section-grid, .section-grid.reverse { 
    flex-direction: column; 
    text-align: center;
  }
  .section-text .desc { margin: 0 auto; }
  .image-container { width: 100%; }
  .lib-banner {
    background-size: cover;
    background-position: center;
  }
  .banner-overlay {
    background: rgba(10, 10, 10, 0.85);
  }
  .lib-banner .container { justify-content: center; text-align: center; }
  .banner-content { margin: 0 auto; }
}
</style>